import { useContext, useEffect, useRef } from 'react';
import { Tooltip, TooltipRefProps } from 'react-tooltip';
import opacitySliderContext from '../../context/opacitySliderContext';
import { useMapEvents } from 'react-leaflet';

interface TooltipControlsProps {
    selected: string[];
}

export const TooltipControls= ({selected}: TooltipControlsProps) => {
     const {opacity}= useContext(opacitySliderContext);
     const tooltipRef = useRef<TooltipRefProps>(null)
     const closeEvents = {
         mouseleave: true,
         blur: true,
         mouseout: true,
         click: true,
         dblclick: true,
         mouseup: true,
     }
     const globalCloseEvents = { 
         escape: true,
         scroll: true,
         resize: true,
         clickOutsideAnchor:true
     }

     const isTouchDevice = () => {
         return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
     }
     const closeTooltip = () => {
         if (isTouchDevice() && tooltipRef.current && tooltipRef.current.isOpen) {
             tooltipRef.current?.close();
         }
     };
     
     useMapEvents({
         click() {
             closeTooltip();
         },
         dragstart() {
                closeTooltip();
         },
         zoomstart() {
                closeTooltip();
         }
     })

     useEffect(() => {
         if (opacity.visible) {
             closeTooltip();
         }
     }, [opacity]);

     // Close tooltip if item is disabled
     useEffect(() => {
        let timer: NodeJS.Timeout | null = null;
        const currentTooltip = (tooltipRef.current as any)?.activeAnchor?.dataset?.tooltipContentSelected;
        
        if (!selected.includes(currentTooltip)) {
            timer = setTimeout(() => {
                closeTooltip();
            }, 500);
        }
    
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [selected]);

    return (
        <Tooltip id="tooltip-custom-controls" className="tooltip-element" noArrow={ true } ref={tooltipRef} globalCloseEvents={globalCloseEvents}
                 closeEvents={ closeEvents }/>
    );
};
